import { SVGProps } from "react"
const SquareMetersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.75 2.5H17.5V6.25"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 7.5L17.5 2.5"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 17.5H2.5V13.75"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 12.5L2.5 17.5"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 13.75V17.5H13.75"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 12.5L17.5 17.5"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 6.25V2.5H6.25"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 7.5L2.5 2.5"
      stroke={props.color || "#011727"}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SquareMetersIcon
